import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from './components/ui/card';
import { FileDown, IndianRupee, PackageOpen, Tag, ArrowLeftRight } from 'lucide-react';
import { useNavigation } from './contexts/NavigationContext';

function Reports({ currentView }) {
  const { navigate } = useNavigation();
  return (
      <main className="w-full px-4 py-8 space-y-8 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="space-y-2 text-left">
          <h1 className="text-4xl font-bold text-left">Reports</h1>
          <p className="text-base text-muted-foreground text-left">Analytics and comprehensive business reports</p>
        </div>

       {/* Action Cards Grid */}
       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
         
         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('downloadSaleSheet')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <FileDown className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Download Sale Sheet</CardTitle>
                 <CardDescription className="text-left">Generate PDF sale reports with financial summary</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('incomeExpensesReport')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <IndianRupee className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Income & Expenses Report</CardTitle>
                 <CardDescription className="text-left">Analyze income sources and expense categories with charts</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('stockLifted')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <PackageOpen className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Stock Lifted Report</CardTitle>
                 <CardDescription className="text-left">Track stock movement and quantities lifted by date</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('brandWiseSales')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <Tag className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Sales Report</CardTitle>
                 <CardDescription className="text-left">Sales analysis by brand with performance metrics</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

         <Card 
           className="cursor-pointer hover:shadow-xl hover:scale-[1.02] hover:border-primary transition-all group"
           onClick={() => navigate('stockTransferReport')}
         >
           <CardHeader className="space-y-4">
             <div className="flex items-start gap-4">
               <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                 <ArrowLeftRight className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
               </div>
               <div className="flex-1 space-y-1.5 text-left">
                 <CardTitle className="text-left">Stock Transfer Report</CardTitle>
                 <CardDescription className="text-left">View and download stock transfer reports by date</CardDescription>
               </div>
             </div>
           </CardHeader>
         </Card>

       </div>
    </main>
  );
}

export default Reports;